export default "__VITE_ASSET__CxvYoXSP__"